import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { passwordPattern } from 'src/app/app.constants';
import { MustMatch, MustNotMatch } from 'src/app/utils/validators/must-match';
import { AuthNewService } from 'src/auth/services/auth-new.service';


interface ChangePasswordModel {
  currentPassword: string;
  newPassword: string;
}


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  form = this.fb.group({
    oldPassword: [null, { validators: [Validators.required, Validators.pattern(passwordPattern)], updateOn: 'blur' }],
    newPassword: [null, { validators: [Validators.required, Validators.pattern(passwordPattern)], updateOn: 'blur' }],
    newPasswordRetype: [null, { validators: [Validators.required, Validators.pattern(passwordPattern)]}]
  }, {
    validators:[ MustMatch('newPassword', 'newPasswordRetype'), MustNotMatch('newPassword', 'oldPassword')]
  });

  constructor(private fb: UntypedFormBuilder, private auth: AuthNewService, private route: ActivatedRoute) { }

  ngOnInit(): void { }

  onSubmit() {

    if (this.form.invalid) {
      return;
    }

    const { oldPassword: currentPassword, newPassword } = this.form.value;


    this.auth.updatePassword( currentPassword, newPassword ).subscribe(response => {

      console.log(response);
    });
  }

}
